import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import {
  toggleReaderToolbarModal,
  toggleReaderNavigationModal,
} from '../actions'

class ToolbarButton extends React.Component {
  static propTypes = {
    position: PropTypes.string.isRequired,
    responsiveDeviceWidth: PropTypes.number.isRequired,
    toggleReaderToolbarModal: PropTypes.func,
    toggleReaderNavigationModal: PropTypes.func,
  }

  state = {
    isModal: $(window).width() < this.props.responsiveDeviceWidth,
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  handleResize = () => {
    if ($(window).width() < this.props.responsiveDeviceWidth) {
      this.setState({ isModal: true })
    } else {
      this.setState({ isModal: false })
    }
  }

  render() {
    const isModal = this.state.isModal
    return (
      <div>
        {this.props.position === 'right' && isModal ? (
          <div
            id="right_panel"
            onClick={() => this.props.toggleReaderToolbarModal(true)}
          >
            <button type="button" className="collapse_bar_right" aria-label="Collapse or expand the right sidebar" aria-controls="right_content">
              <div className="fas fa-ellipsis-v" />
            </button>
          </div>
        ) : this.props.position === 'right' ? (
          <div id="right_panel">
            <button type="button" className="rightClose collapse_bar_right" aria-label="Collapse or expand the right sidebar" aria-controls="right_content">
              <div className="fas fa-ellipsis-v" />
            </button>
          </div>
        ) : this.props.position === 'left' && isModal ? (
          <div
            id="left_panel"
            onClick={() => this.props.toggleReaderNavigationModal(true)}
          >
            <button type="button" className="collapse_bar_left" aria-label="Collapse or expand the left sidebar" aria-controls="left_content">
              <div className="fas fa-ellipsis-v" />
            </button>
          </div>
        ) : this.props.position === 'left' ? (
          <div id="left_panel">
            <button type="button" className="leftClose collapse_bar_left" aria-label="Collapse or expand the left sidebar" aria-controls="left_content">
              <div className="fas fa-ellipsis-v" />
            </button>
          </div>
        ) : (
          <div />
        )}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    responsiveDeviceWidth: state.responsiveDeviceWidth,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    toggleReaderToolbarModal: readerToolbarModalState => {
      dispatch(toggleReaderToolbarModal(readerToolbarModalState))
    },
    toggleReaderNavigationModal: readerNavigationModalState => {
      dispatch(toggleReaderNavigationModal(readerNavigationModalState))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ToolbarButton)
